import React from 'react'
import { ErrorBoundary, QuickRenew } from '@rebeldotcom/ui'
import { Stack } from '@rebeldotcom/components'
import Layout from '../../components/layout'

export default function QuickRenewPage() {
  return (
    <Layout>
      <Stack
        alignItems="center"
        height="80vh"
        justifyContent="center"
        width="100%"
      >
        <ErrorBoundary>
          <QuickRenew />
        </ErrorBoundary>
      </Stack>
    </Layout>
  )
}
